import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FixedRoutes, Modules } from '@urls';
import { jwtDecode } from 'jwt-decode';
import { BehaviorSubject } from 'rxjs';
import { EmployeeProfile } from './auth.model';
import { DataService } from './data.service';
import { ApiResponse, StatusFlags } from './data.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root', })

export class AuthService {
  public currentUser: EmployeeProfile | null = null;
  public tenantCode: string = '';
  public isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public dataService = inject(DataService);
  public router = inject(Router);

  constructor() {
    if (this.decodeToken() && this.currentUser && this.currentUser.isTempPassword) { this.router.navigateByUrl(`${FixedRoutes.Auth}/${FixedRoutes.ResetPass}`); }
  }

public login(user: { username: string, password: string }): Promise<ApiResponse<string>> {
  return this.dataService.post<string>(`${Modules.Auth}`, user)
    .then((response: ApiResponse<string>) => {
      if (response.status === StatusFlags.Success && response.data) {
        this.setupUser(response.data);
      }
      return response;
    });
}


  public reset(data: { currentPassword: string, newPassword: string }): void {
    this.dataService.post<string>(`${Modules.Reset}`, data).then((response: ApiResponse<string>) => {
      if (response.status === StatusFlags.Success && response.data) {
        this.setupUser(response.data);
      }
    });
  }

  public changePassword(data: { currentPassword: string, newPassword: string, confirmPassword: string }): void {
    this.dataService.post<string>(`${Modules.changePassword}`, data).then((response: ApiResponse<string>) => {
      if (response.status === StatusFlags.Success && response.data) {
        // this.setupUser(response.data);
         localStorage.AccessToken = response.data;
      }
    });
  }

  public companyToken(companyId: number): void {
    this.dataService.post<string>(`${Modules.CompanyToken}`, companyId).then((response: ApiResponse<string>) => {
      if (response.status === StatusFlags.Success && response.data) {
        this.setupUser(response.data, false);
      }
    });
  }

  private setupUser(token: string, redirect: boolean = true): void {
    localStorage.AccessToken = token;
    localStorage.Locked = false;
    if (this.decodeToken()) {
      this.isAuthenticated.next(true);
      if (redirect) {
        if (this.currentUser?.isTempPassword) {
          this.router.navigateByUrl(`${FixedRoutes.Auth}/${FixedRoutes.ResetPass}`);
        } else {
            this.router.navigateByUrl(FixedRoutes.Dashboard);
        }
      } else { window.location.reload(); }
    }
  }

  public logout(): void {
    this.currentUser = null;
    localStorage.clear();
    this.isAuthenticated.next(false);
    this.router.navigateByUrl(FixedRoutes.Auth);
  }

  public lock(): void {
    localStorage.Locked = true;
    this.isAuthenticated.next(false);
    this.router.navigateByUrl(`${FixedRoutes.Auth}/${FixedRoutes.Lock}`);
  }

  public unlock(password: string): void {
    if (this.currentUser?.username) {
      this.login({ username: this.currentUser?.username || '', password: password });
    }
  }

  public forgotPassword(data: {email: string}): void{
    this.dataService.post<string>(`${environment.apiURL}api/Auth/ForgotPassword`, data).then((response: ApiResponse<string>) => {
      if(response.status === StatusFlags.Success){
      }else{
      }
    }).catch(err =>{
      console.error("Error in forgot password request", err);

    })
  }

  private decodeToken(): boolean {
    let isDecoded = false;
    if (localStorage.AccessToken) {
      const decodedToken = jwtDecode(localStorage.AccessToken);
      const userDataKey = Object.keys(decodedToken).find(d => d.includes("userdata"));
      if (userDataKey) {
        const userdata = (decodedToken as any)[userDataKey];
        this.currentUser = JSON.parse(userdata);
        isDecoded = true;
      }
    }
    return isDecoded;
  }
}
